<h1 mat-dialog-title>Schlachtung beauftragen f&uuml;r {{ gruppe?.bezeichnung }}</h1>
<div mat-dialog-content style="height: 100%">
    <mat-form-field style="width: 100%">
        <mat-label>Anzahl</mat-label>
        <input matInput [formControl]="countCtrl" />
        <span matSuffix>/ {{ gruppe?.anzahl_tiere_aktuell }}</span>
    </mat-form-field>
    <mat-form-field style="width: 100%">
        <mat-label>Viehändler</mat-label>
        <mat-select [formControl]="haendlerCtrl">
            <mat-option *ngFor="let haendler of favoritenHaendler" [value]="haendler"
                >{{ haendler?.bezeichnung }}
            </mat-option>
        </mat-select>
    </mat-form-field>
    <mat-checkbox [(ngModel)]="useHaendlerAsDefault">
        <span style="text-wrap: wrap">Als Standardhändler übernehmen</span>
    </mat-checkbox>
    <button
        mat-stroked-button
        color="accent"
        style="margin-top: 24px"
        (click)="openBottomSheet()"
        [disabled]="!countCtrl.value || !haendlerCtrl.value"
        >Termin auswählen</button
    >
    <div matLine *ngIf="selectedSlot" style="margin-top: 24px">
        {{ selectedSlot?.datum_uhrzeit_von | date: "dd.MM.YY" }}
        {{ " " + selectedSlot?.datum_uhrzeit_von | date: "HH:mm" }} -
        {{ selectedSlot?.datum_uhrzeit_bis | date: "HH:mm" }} Uhr
    </div>
</div>
<div mat-dialog-actions align="end">
    <button (click)="dialogRef.close()" mat-button>Abbrechen</button>
    <button (click)="buchungAbschliessen()" mat-flat-button color="accent" [disabled]="!isValid()">
        Beauftragung anfragen
    </button>
</div>
